class PageFaq extends HTMLElement {
    constructor() {
        super();
        this.tabs = document.querySelectorAll("[data-tab]");
        this.tabPanels = document.querySelectorAll("[data-tab-panel]");
        this.dropDownItems = document.querySelectorAll("[data-dropdown-item]");
        this.dropDownTrigger = document.querySelector(".component--faq--dropdown__trigger");
        this.bindEvents();
        this.tabPanels[0].classList.add('page--faq--questions--active');
        this.dropDownItems[0].classList.add('component--faq--dropdown__item--active');
    }
    bindEvents() {
        this.tabs.forEach(tab => tab.addEventListener('click', this.open.bind(this)));
        this.dropDownItems.forEach(item => item.addEventListener('click', this.selectDropDownItem.bind(this)));
        this.dropDownTrigger.addEventListener('click', this.openDropDown.bind(this))
    }
    selectDropDownItem() {
        const selectedItem = event.currentTarget;
        const selectedItemName = selectedItem.getAttribute('data-dropdown-item');
        this.dropDownItems.forEach((item, index) => {
            if (this.tabPanels[index] != undefined) {
                const itemName = item.getAttribute('data-dropdown-item');
                document.querySelector('.component--faq--dropdown__text').innerHTML = selectedItemName;
                if (itemName === selectedItemName) {
                    item.classList.add('component--faq--dropdown__item--active');
                } else {
                    item.classList.remove('component--faq--dropdown__item--active');
                }
            }
        });
        this.tabPanels.forEach((panel, index) => {
            if (this.dropDownItems[index] != undefined) {
                const tabPanelName = panel.getAttribute('data-tab-panel');
                if (tabPanelName === selectedItemName) {
                    panel.classList.add('page--faq--questions--active');
                } else {
                    panel.classList.remove('page--faq--questions--active');
                }
            }
        });
        const dropDownList = document.querySelector('.component--faq--dropdown__list');
        dropDownList.classList.remove('component--faq--dropdown__list--active');
        this.dropDownTrigger.classList.remove('component--faq--dropdown__trigger--active');
    }
    openDropDown(event) {
        const dropDownList = document.querySelector('.component--faq--dropdown__list');
        dropDownList.classList.toggle('component--faq--dropdown__list--active');
        this.dropDownTrigger.classList.toggle('component--faq--dropdown__trigger--active');
    }
    open(event) {
        const selectedTab = event.currentTarget;
        const selectedTabName = selectedTab.getAttribute('data-tab');
        this.tabs.forEach((tab, index) => {
            if (this.tabPanels[index] != undefined) {
                const tabName = tab.getAttribute('data-tab');
                if (tabName === selectedTabName) {
                    tab.classList.add('page--faq--categories__item--active');
                } else {
                    console.log(this.tabPanels[index])
                    tab.classList.remove('page--faq--categories__item--active');
                }
            }
        });
        this.tabPanels.forEach((panel, index) => {
            if (this.tabs[index] != undefined) {
                const tabPanelName = panel.getAttribute('data-tab-panel');
                if (tabPanelName === selectedTabName) {
                    panel.classList.add('page--faq--questions--active');
                } else {
                    panel.classList.remove('page--faq--questions--active');
                }
            } else {
            }
        });
    }
  }
  customElements.define('page-faq', PageFaq);